import React from "react";
import image1 from '../../Assets/Project3/testPart/test & learn 1.webp';
import image2 from '../../Assets/Project3/testPart/test & learn 2.webp';
import image3 from '../../Assets/Project3/testPart/test & learn 3.webp';
import image4 from '../../Assets/Project3/testPart/test & learn 4.webp';
import image5 from '../../Assets/Project3/testPart/test & learn 5.webp';
import image6 from '../../Assets/Project3/testPart/test & learn 6.webp';
import image7 from '../../Assets/Project3/testPart/test & learn 7.webp';
import image8 from '../../Assets/Project3/testPart/test & learn 8.webp';
import image9 from '../../Assets/Project3/testPart/test & learn 9.webp';
import image10 from '../../Assets/Project3/testPart/test & learn 10.webp';
import image11 from '../../Assets/Project3/testPart/test & learn 11.webp';
import image12 from '../../Assets/Project3/testPart/test & learn 12.webp';
import image13 from '../../Assets/Project3/testPart/test & learn 13.webp';
import image14 from '../../Assets/Project3/testPart/test & learn 14.webp';
import image15 from '../../Assets/Project3/testPart/test & learn 15.webp';
import image16 from '../../Assets/Project3/testPart/test & learn 16.webp';
import image17 from '../../Assets/Project3/testPart/test & learn 17.webp';
import image18 from '../../Assets/Project3/testPart/test & learn 18.webp';
import image19 from '../../Assets/Project3/testPart/test & learn 19.webp';



const TestPart = () => {
    return (
        <div className="testPart-container">
            <h1>User Testing</h1>
            <p>We conducted proper user testing in UT room with our target audience and redesigned the book with the help of their feedback and our observations</p>

            <div className="testPart-images-grid">
                <img src={image1} className="testPart-grid-image" />
                <img src={image2} className="testPart-grid-image" />
                <img src={image3} className="testPart-grid-image" />
                <img src={image4} className="testPart-grid-image" />
                <img src={image5} className="testPart-grid-image" />
                <img src={image6} className="testPart-grid-image" />
                <img src={image7} className="testPart-grid-image" />
                <img src={image8} className="testPart-grid-image" />
                <img src={image9} className="testPart-grid-image" />
                <img src={image10} className="testPart-grid-image" />
                <img src={image11} className="testPart-grid-image" />
                <img src={image12} className="testPart-grid-image" />
                <img src={image13} className="testPart-grid-image" />
                <img src={image14} className="testPart-grid-image" />
                <img src={image15} className="testPart-grid-image" />
                <img src={image16} className="testPart-grid-image" />
                <img src={image17} className="testPart-grid-image" />
                <img src={image18} className="testPart-grid-image" />
                <img src={image19} className="testPart-grid-image" />
            </div>
        </div>
    );
};

export default TestPart;